export const INTERNAL_RECURRENCE_PIECE = 'org.olf.internalPiece.InternalRecurrencePiece';
export const INTERNAL_OMISSION_PIECE = 'org.olf.internalPiece.InternalOmissionPiece';
export const INTERNAL_COMBINATION_PIECE = 'org.olf.internalPiece.InternalCombinationPiece';
